module.exports = __webpack_public_path__ + "060096220a07920f30b3bca99a42e910.pdf";